import React from 'react';
import TunesIcon from '@/components/Icons/TunesIcon';
import { RADIO_COLORS } from '@/config/constants';

export interface ThumbCardProps {
  title: string;
  description?: string;
  photo: string;
  altText?: string;
  hideImage?: boolean;
  radioId?: string;
}

const ThumbCard: React.FC<ThumbCardProps> = ({ title, description, photo, altText, hideImage, radioId }) => {
  const colors = radioId && radioId in RADIO_COLORS ? RADIO_COLORS[radioId] : RADIO_COLORS[''];
  return (
    <div className={'flex flex-row items-center'}>
      <div
        className={`col-auto mr-0 flex items-center justify-items-center ${
          hideImage ? 'collapse hidden' : 'hidden w-24 md:flex lg:pr-4'
        }`}
      >
        {photo ? (
          <div className={`flex items-center`} style={{ height: '60px' }}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={photo}
              alt={altText}
              className="pointer-events-none rounded-4"
              style={{ width: '61' }}
              width={61}
            />
          </div>
        ) : (
          <TunesIcon primaryColor={colors.primary} secondaryColor={colors.secondary} />
        )}
      </div>
      <div className={`lg:mw-48 my-auto block ${hideImage ? '' : 'md:hidden lg:block'}`}>
        <div className={'text-matte-black font-bold'}>{title}</div>
        <div className={'text-gray-500'}>{description}</div>
      </div>
    </div>
  );
};

export default ThumbCard;
